require('./bootstrap')
import Vue from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VModal from 'vue-js-modal'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VueSweetalert2, {
  allowOutsideClick: false,
  allowEscapeKey: false,
  focusConfirm: false,
  returnFocus: false,
  buttonsStyling: false,
  confirmButtonText: 'Aceptar',
  denyButtonText: 'Rechazar',
  cancelButtonText: 'Cancelar',
  customClass: {
    icon: '!hidden',
    popup: '!rounded-3xl !surface1 !p-6 !w-auto',
    title: '!text-on-surface !font-sans !text-left !font-medium !text-2xl !p-0 !pb-4',
    htmlContainer:
      '!text-on-surface-variant !font-sans !text-base !text-left !m-0 !tracking-tight !text-start',
    actions: '!m-0 !justify-end !m-0 !ml-4 !mt-6 !gap-2',
    confirmButton: 'btn-text py-2.5 px-3',
    denyButton: 'btn-text py-2.5 px-3',
    cancelButton:
      'btn-text py-2.5 px-3 text-error hover:bg-error-container hover:text-on-error-container focus:bg-error-container focus:text-on-error-container focus-visible:outline-error focus-visible:bg-error-container active:text-on-error-container ',
  },
})

Vue.use(VModal)
Vue.use(VuePlyr)

Vue.prototype.$route = route
Vue.prototype.$window = Vue.observable({ width: window.innerWidth, height: window.innerHeight })
window.addEventListener('resize', () => {
  Vue.prototype.$window.width = window.innerWidth
  Vue.prototype.$window.height = window.innerHeight
})

createInertiaApp({
  title: title => (title !== 'Bolsa de Trabajo' ? title + ' - Bolsa de Trabajo' : title),
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      render: h => h(app, props),
    }).$mount(el)
  },
})
